import { UserRole } from '@/state/use-admin';
import { Ghost, LucideIcon, Server, User, UserSearch } from 'lucide-react';

export interface SiteConfig {
	name: string;
}

export const siteConfig: SiteConfig = {
	name: '75/admin',
};

export interface SubModule {
	title: string;
	icon: LucideIcon;
	href: string;
	needUserRole: UserRole;
}

export const GameModules: SubModule[] = [
	{
		title: '玩家查询',
		icon: UserSearch,
		href: 'user-query',
		needUserRole: UserRole.USER,
	},
	{
		title: '角色查询',
		icon: Ghost,
		href: 'character-query',
		needUserRole: UserRole.USER,
	},
	{
		title: '服务器列表',
		icon: Server,
		href: 'server-list',
		needUserRole: UserRole.USER,
	},
	{
		title: 'gm命令执行',
		icon: User,
		href: 'gm-cmd',
		needUserRole: UserRole.USER,
	}
];

export const SettingModules: SubModule[] = [
	{
		title: '用户列表',
		icon: User,
		href: 'users',
		needUserRole: UserRole.ADMIN,
	},
];

export enum ProjectType {
	HuangDi = 1,
}

export const baseUrl =
	import.meta.env.VITE_API_BASE_URL || 'http://localhost:51100';

console.log('baseUrl:', baseUrl);
